module.exports = __webpack_public_path__ + "static/media/bancolombia-icon_salary_006.a3f5ca8b.svg";